import { z } from "zod";
import type {
    AnomalyDetectionCheckType,
} from "../types/preferences_types";

const schemas: Record<AnomalyDetectionCheckType, z.ZodTypeAny> = {
    wrong_unique_field_value: z.object({ unique_field_name: z.string().min(1) }),
    number_greater_than_zero: z.object({ field: z.string().min(1) }),
    row_count_limit_exceeded: z.object({ row_count_limit: z.number().int() }),
    row_count_percentage_difference: z.object({ percentage_threshold: z.number() }),
    collection_time_percentage_difference: z.object({ percentage_threshold: z.number() }),
    file_size_percentage_difference: z.object({ percentage_threshold: z.number() }),
    missing_data: z.object({
        key_rules: z.array(z.record(z.unknown())),
        unique_fields: z.array(z.string().min(1)),
    }),
};

export function validateKwargsByCheckType(checkType: AnomalyDetectionCheckType, rawJson: string) {
    try {
        const parsed = JSON.parse(rawJson);
        const result = schemas[checkType].parse(parsed);
        return { ok: true as const, value: result as Record<string, unknown> };
    } catch {
        return { ok: false as const, error: "체크 타입 별 인자 값이 유효하지 않습니다." };
    }
}
